<template>
    <b-card :title="$t('Component(Text):general-info')">

        <div class="mb-1">
            <strong>{{ $t('Component(Grid):column-id') }}:</strong>
            <span class="ml-50">{{ safeProcessId }}</span>
        </div>

        <div class="mb-1">
            <strong>{{ $t('Component(ComplianceOverview):column-status') }}:</strong>
            <b-badge class="ml-50" :variant="statusVariant">
                {{ translatedStatus }}
            </b-badge>
        </div>

        <div class="mb-1">
            <strong>{{ $t('Component(Grid):column-title') }}:</strong>
            <span class="ml-50">{{ safeTitle }}</span>
        </div>

        <div>
            <strong>{{ $t('Page(SystemServices):Component(Text):description') }}:</strong>
            <span class="ml-50">{{ safeDescription }}</span>
        </div>

        <div class="mt-1 mb-1">
            <strong>{{ $t('Component(Label):created-at') }}:</strong>
            <span class="ml-50">{{ safeCreatedAt }}</span>
        </div>

        <div>
            <strong>{{ $t('Component(Label):updated-at') }}:</strong>
            <span class="ml-50">{{ safeUpdatedAt }}</span>
        </div>
    </b-card>
</template>

<script>
import {BCard, BBadge} from 'bootstrap-vue'
import dateRenderer from '@core/mixins/date-renderer'

export default {
    name: 'ResearchReviewGeneralInformation',
    components: {
        BCard,
        BBadge,
    },
    mixins: [dateRenderer],
    props: {
        process: {
            type: Object,
            default: null,
        },
    },
    computed: {
        safeProcessId() {
            return this.process && this.process.processId ? this.process.processId : '-'
        },
        translatedStatus() {
            const status = this.process && this.process.status ? this.process.status : null
            if (!status) {
                return '-'
            }

            return this.$t('Component(ResearchReviewProcessEnum):status-' + status)
        },
        statusVariant() {
            const status = this.process && this.process.status ? this.process.status : null

            if (status === 'completed') {
                return 'success'
            }

            if (status === 'pending_human_review' || status === 'pending_machine_review') {
                return 'warning'
            }

            return 'secondary'
        },
        safeCreatedAt() {
            const value = this.process && this.process.createdAt ? this.process.createdAt : null
            return value ? this.renderDateTime(value) : '-'
        },
        safeUpdatedAt() {
            const value = this.process && this.process.updatedAt ? this.process.updatedAt : null
            return value ? this.renderDateTime(value) : '-'
        },
        safeTitle() {
            const context = this.process && this.process.externalContext ? this.process.externalContext : {}
            return context.title || '-'
        },
        safeDescription() {
            const context = this.process && this.process.externalContext ? this.process.externalContext : {}
            return context.description || '-'
        },
    },
}
</script>
